$(function () {
  // カートに商品の追加
  $('.cart-add-btn').on('click', function (event) {
    event.stopPropagation();
    event.stopImmediatePropagation();

    np_en.lock();

    // ajaxでカート追加
    let item_id = $(this).data('item-id');
    $form = $('#form' + item_id);
    let serializeArrayData = $form.serializeArray();


    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: serializeArrayData,
      dataType: 'json',
    }).done(function (data) {
      np_en.unlock();
      console.log(data);
      // カートの上に表示される数量を更新
      let cart_amounts = $('.cart-amount');
      cart_amounts.each(function (index, element) {
        // カートが存在していなかった場合は非表示にしているため、表示
        $(element).css('display', '');
        // 総量をカートのバッジに代入
        $(element).html(data['total_amount']);
      });
      $.when(
        // ダイアログに値をセット
        setItemDataToDialog(data)
      ).done(
        //　ダイアログを表示
        $('#cart-add-dialog').fadeIn(500, function () {
          $(this).delay(3000).fadeOut(1000);
        })
      );
    })
  });

  let setItemDataToDialog = function (data) {
    // 商品画像URL
    let item_img = $('#dialog-item-image');
    $(item_img).attr('alt', data['item']['item_image_alt']);
    $(item_img).attr('src', data['item']['item_image_url']);

    // 販売元・発売元区分
    $('.cart-dialog-info .sales-company-title').text(data['item']['sales_company_title']);

    // 販売元
    $('.cart-dialog-info .sales-agency').text(data['item']['sales_company_name']);

    // 商品名
    $('.cart-dialog-info .product-name').text(data['item']['item_name_site']);

    // 税込金額
    let price = '';
    if (data['item']['bargain_class'] == 1) {
      price = data['item']['special_price'];
      $('.price').addClass('bargain-price');

    } else if (data['item']['bargain_class'] == 0) {
      if (data['item']['bargain_assign_class'] == 1) {
        price = data['item']['bargain_assign_price'];

      } else if (data['item']['bargain_assign_class'] == 0) {
        price = data['item']['sales_price'];
      }
    }
    $('.cart-dialog-info .sales-price').text('$' + price);

    // 数量
    $('.cart-dialog-info .amount').text(data['amount']);
  }
});
